import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import FnrTypography from "FnrTypography";

import {
  Body as BodyStarter,
  Title as TitleStarter,
  TitleWrapper,
  Wrapper,
  linkBaseStyles,
} from "../Styles";

import wofLogo from "./engage-flame-lt-orange.png";
import libraryBookImg from "./library-book.png";

Library.propTypes = {
  hasWOF: PropTypes.bool,
  canCompose: PropTypes.bool,
  networkID: PropTypes.number,
};

export default function Library({ hasWOF, canCompose, networkID }) {
  const handleVisitLibraryClick = () => {
    try {
      window.fnReactBus.openLibrary();
    } catch (e) {
      // fail silently in dev env
    }
  };

  const handleVisitWOFClick = () => {
    window.open(`/integrations/wofSignIn/${networkID}`);
  };

  if (!canCompose) return null;

  return (
    <StyledWrapper>
      <TitleWrapper>
        <Title>
          <FnrTypography color="white" type="subheader" fontWeight={300}>
            Content & Template Library{" "}
            {hasWOF ? <WOFTitle>plus Word on Fire Engage</WOFTitle> : ""}
          </FnrTypography>
        </Title>

        <BookImg src={libraryBookImg} alt="" />

        {hasWOF ? <WOFLogo src={wofLogo} /> : null}
      </TitleWrapper>
      <Body>
        {hasWOF ? (
          <WOFIncludedLine>
            <FnrTypography
              color="rgba(255, 255, 255, 0.85)"
              type="subheader"
              italic
            >
              Included with Flocknote Complete
            </FnrTypography>
          </WOFIncludedLine>
        ) : null}

        <FnrTypography color="rgba(255, 255, 255, 0.85)" type="copy">
          The Library has free pre-made email templates, content, and lessons
          you can quickly copy, edit, and send out to your members.
          {hasWOF ? (
            <span>
              {" "}
              PLUS exclusive,{" "}
              <a
                href="https://help.flocknote.com/article/155-how-to-add-word-on-fire-content-to-your-flocknote"
                target="_blank"
                rel="noreferrer"
              >
                meaningful Word on Fire content
              </a>{" "}
              ready to share with your parish.
            </span>
          ) : (
            ""
          )}
        </FnrTypography>
      </Body>

      <Links>
        <Link onClick={handleVisitLibraryClick} $big={!hasWOF}>
          <FnrTypography color="white" fontWeight={800}>
            Visit the Library <ChevronIcon className="fas fa-chevron-right" />
          </FnrTypography>
        </Link>

        {hasWOF ? (
          <Link onClick={handleVisitWOFClick}>
            <FnrTypography color="white" fontWeight={800}>
              Visit WOF Digital <ChevronIcon className="fas fa-chevron-right" />
            </FnrTypography>
          </Link>
        ) : null}
      </Links>
    </StyledWrapper>
  );
}

const StyledWrapper = styled(Wrapper)`
  background-color: #182941;
`;

const Title = styled(TitleStarter)`
  color: white;
`;

const WOFTitle = styled.span`
  font-style: italic;
  color: #ecc27b;
  font-weight: 600;
`;

const BookImg = styled.img`
  width: 42px;
  margin-right: 8px;
  margin-top: -8px;

  @media (max-width: 840px) {
    margin-top: 0;
  }
`;

const WOFLogo = styled.img`
  position: absolute;
  width: 19px;
  right: 20px;
  top: -32px;

  @media (max-width: 1250px) {
    top: -38px;
  }
`;

const Body = styled(BodyStarter)`
  color: rgba(255, 255, 255, 0.7);
  padding: 10px 0 12px;

  a {
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer !important;
  }
`;

const WOFIncludedLine = styled.div`
  margin-bottom: 14px;
`;

const Links = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Link = styled.span`
  ${linkBaseStyles}
  color: white !important;
  cursor: pointer !important;
  font-size: ${({ $big }) => ($big ? "16px" : "14px")};
`;

const ChevronIcon = styled.span`
  font-size: 12px;
`;
